import { Pipe, PipeTransform, Inject } from '@angular/core';
import { ITranslationService, I18NEXT_SERVICE } from 'angular-i18next';

const I18N_PREFIX = 'translation:';

@Pipe({
  name: 't',
})
export class TPipe implements PipeTransform {
  constructor(@Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService) {}

  transform(keys: string | string[], context?: object | any): string | object | any {
    if (Array.isArray(keys)) {
      const transKeys = keys.map((key) => I18N_PREFIX + key);
      return this.i18NextService.t(transKeys, context);
    } else {
      return this.i18NextService.t(I18N_PREFIX + keys, context);
    }
  }
}
